import dJSON from 'dirty-json';

import Splide from '@splidejs/splide';

const moduleSelector = '.image-slider';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.splide__list').insertAdjacentHTML('beforeend', /* html */ `
          <div class="splide__slide">
            ${item.link ? `<a class="image-wrapper" href="${item.link}" target="_blank">` : '<div class="image-wrapper">'}
              <img src="${item.background}" alt="${item.alt}" />
            ${item.link ? '</a>' : '</div>'}
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

(() => {
  document.querySelectorAll('.image-slider .splide').forEach((item) => {
    const slider = new Splide(item, {
      type: 'slide',
      perPage: 4,
      perMove: 1,
      gap: 25,
      pagination: false,
      arrows: false,
      autoplay: true,
      breakpoints: {
        768: {
          perPage: 2,
        },
      },
    });
    slider.mount();
  });

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();
